import { createMasonryEngineNodeRenderersRegistry } from '@leagueplatform/masonry-engine';
import { type MasonryWSDriverNode } from '@leagueplatform/masonry-widgets';
import { MasonrySpinnerNode } from '#components/spinner/spinner.component.tsx';
import { MasonryWSDriverDefaultNodeRendererMap } from './masonry-WS-default-node-renderers-map';

export type MasonryWSDriverRegistryNode =
  | MasonryWSDriverNode
  | MasonrySpinnerNode;

export const MasonryWSDriverNodeRenderersRegistry =
  createMasonryEngineNodeRenderersRegistry<MasonryWSDriverRegistryNode>(
    MasonryWSDriverDefaultNodeRendererMap,
  );
